import { isDevEnv, isRNDev } from "utilities/src/environment/env";
import { isMobileApp } from "utilities/src/platform";
const isVitestRun = !!process.env.VITEST_POOL_ID;
export const isJestRun = !!process.env.JEST_WORKER_ID;
export const isNonTestDev = !isVitestRun && !isJestRun && (isMobileApp ? isRNDev() : isDevEnv());
export const localDevDatadogEnabled = false;
export const datadogEnabledBuild = (localDevDatadogEnabled || !isRNDev()) && !isJestRun && !isVitestRun;
